import PageBuilder from '@commons/pagebuilder';
import type { DrupalBlock, DrupalNode } from '@commons/types/drupal';

// Type definition for the NodeBlock component properties.

type Props = DrupalBlock<DrupalNode>;

/**
 * Node block component.
 */

const NodeBlock = ({ content }: Props) => {
  return PageBuilder.renderNode(content);
};

export default NodeBlock;
